import { ChevronDownIcon, RepeatIcon } from '@/components/atoms'
import { useLanguageSwitcher } from './language-switcher.hook'

export const LANGUAGE_SWITCHER_VARIANT = {
  TOGGLE: 'toggle',
  DROPDOWN: 'dropdown',
} as const

type LanguageSwitcherVariant =
  (typeof LANGUAGE_SWITCHER_VARIANT)[keyof typeof LANGUAGE_SWITCHER_VARIANT]

interface LanguageSwitcherProps {
  variant?: LanguageSwitcherVariant
}

export function LanguageSwitcher({
  variant = LANGUAGE_SWITCHER_VARIANT.TOGGLE,
}: LanguageSwitcherProps) {
  const {
    currentLanguage,
    toggleLanguage,
    switchLabel,
    isOpen,
    toggleDropdown,
    selectLanguage,
    containerRef,
    languages,
  } = useLanguageSwitcher()

  if (variant === LANGUAGE_SWITCHER_VARIANT.DROPDOWN) {
    return (
      <div ref={containerRef} className="relative">
        <button
          onClick={toggleDropdown}
          className="flex cursor-pointer items-center gap-1 bg-white text-sm font-medium text-gray-800 transition-colors"
        >
          {currentLanguage === 'en' ? 'ENG' : 'ESP'}
          <ChevronDownIcon
            className={`color-indigo-base text-indigo-base h-6 w-6 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}
          />
        </button>

        {isOpen && (
          <ul className="absolute right-0 z-[var(--z-header)] mt-1 min-w-[7rem] overflow-hidden rounded-md border border-gray-200 bg-white shadow-md">
            {languages.map(({ code, label }) => (
              <li key={code}>
                <button
                  onClick={() => selectLanguage(code)}
                  className={`w-full cursor-pointer px-4 py-2 text-left text-base transition-colors hover:bg-gray-100 ${
                    currentLanguage === code
                      ? 'text-purple-default font-semibold'
                      : 'text-gray-700'
                  }`}
                  title={label}
                >
                  {label}
                </button>
              </li>
            ))}
          </ul>
        )}
      </div>
    )
  }

  return (
    <button
      onClick={toggleLanguage}
      className="flex items-center gap-2 text-base text-black transition-colors hover:text-gray-900"
    >
      {switchLabel}
      <RepeatIcon className="text-indigo-base h-6 w-6" />
    </button>
  )
}
